import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar, private zone: NgZone) {}

  /**
   * Open SNack Bar
   * @description opens a material snackbar with given message and action
   * @param {string} message
   * @param {string} action
   * @memberof SnackbarService
   */
  openSnackBar(message: string, action: string) {
    this.zone.run(() => {
      setTimeout(() => {
        this.snackBar.open(message, action, {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['pre-line-snackbar']
        });
      }, 0);
    });
  }

  /**
   * Open a success styled snack bar
   * @description light panel with a success mark, for confirming an action that
   * completed and needs no acknowledgement
   * @param {string} message
   * @param {string} action
   * @memberof SnackbarService
   */
  openSuccessSnackBar(message: string, action: string = 'Dismiss') {
    this.zone.run(() => {
      setTimeout(() => {
        this.snackBar.open(message, action, {
          duration: 6000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['pre-line-snackbar', 'success-snackbar']
        });
      }, 0);
    });
  }
}
